import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  reportOptions: {
    cover_page: true,
    client_profile: true,
    default_retirement_plan: true,
    redesigned_income_plan: true,
    income_by_year: true,
    assets_by_year: true,
  },
  error: null
};

export const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    setReportOptions: (state, action) => {
      state.reportOptions = action.payload;
      state.error = null;
    },
    toggleReportOption: (state, action) => {
      const optionName = action.payload;
      state.reportOptions[optionName] = !state.reportOptions[optionName];
      state.error = null;
    },
    resetReportOptions: (state) => {
      state.reportOptions = initialState.reportOptions;
      state.error = null;
    },
    setReportError: (state, action) => {
      state.error = action.payload;
    }
  },
});

export const {
  updateReports,
  setReportOptions,
  toggleReportOption,
  resetReportOptions,
  setReportError
} = reportsSlice.actions;

// Selectors
export const getReportOptions = (state) => state.reports.reportOptions;
export const getReportError = (state) => state.reports.error;

export default reportsSlice.reducer;
